import React from 'react'
import { Routes, Route } from "react-router-dom"
import Contact from './Contact'
import Dashboard from './Dashboard'
import Enquiry from './Enquiry'
import Login from './Login'

const CommonRoutes = () => {
    return (
        <div>
            <div className="container-fluid" id="main">
                <div className="row row-offcanvas row-offcanvas-left">
                    <Routes>
                        {/* <Route path='/' element={<Dashboard />} exact /> */}
                        <Route path='/' element={<Dashboard />} />
                        <Route path='/login' element={<Login />} />
                        <Route path='/enquiry' element={<Enquiry />} />
                        <Route path='/contact' element={<Contact />} />
                    </Routes>
                </div>
            </div>
        </div>
    )
}

export default CommonRoutes